// TODO: to be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
// LEGACY MILEAGE-LOCK group; see RequestMileageConfiguration.ts
import { useQuery } from 'react-query'

import { RequestMileageConfiguration } from '@webapp/modules/expense/entities/RequestMileageConfiguration'
import { expenseQueryConfig } from '@webapp/modules/expense/query-configs/expense'

type UseQueryMileageLockSettingReturn = {
  mileageLockSetting: RequestMileageConfiguration | null
  isLoading: boolean
  isError: boolean
}

export const useQueryMileageLockSetting =
  (): UseQueryMileageLockSettingReturn => {
    const { data, isLoading, isError } = useQuery(
      expenseQueryConfig.mileageLockSetting()
    )

    return {
      mileageLockSetting: data ? new RequestMileageConfiguration(data) : null,
      isLoading,
      isError,
    }
  }
